export class BackendError extends Error {
  constructor (message, details) {
    super()
    this.message = message
    this.stack = (new Error()).stack
    this.name = this.constructor.name
    this.details = details
  }
}
